import { render, staticRenderFns } from "./vue-modaltor.vue?vue&type=template&id=6000841e&"
import script from "./vue-modaltor.vue?vue&type=script&lang=js&"
export * from "./vue-modaltor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports